module.exports = __webpack_public_path__ + "static/peas-e1383777ae7b19c966b8d78c883d40ca.svg";